import { DomSizeContext, DomSizeSettings } from '@/components/dom-size/helpers';
import { useContext } from 'react';

const useSizeContext = () => useContext<DomSizeSettings>(DomSizeContext);

export default useSizeContext;
